/**
 * Integration keys used to identify different integration types
 */
export const INTEGRATION_KEYS = {
  GOOGLE_TAG_MANAGER: 'google-tag-manager',
  GOOGLE_ANALYTICS: 'google-analytics',
  HOTJAR: 'hotjar',
};

/**
 * Customization keys used within integration customizations objects
 */
export const CUSTOMIZATION_KEYS = {
  GTM_KEY: 'Google-Tag-Manager-Key',
  GA_MEASUREMENT_ID: 'Google-Analytics-Measurement-ID',
  HOTJAR_SITE_ID: 'Hotjar-site-ID', // Fixed typo: was 'Hotjat-site-ID'
};

/**
 * Chatbot types
 */
export const CHATBOT_TYPES = {
  CRISP: 2,
  HUBSPOT: 3,
  CHATBOT_COM: 4,
  LANDBOT: 5,
};
